import React from "react";
import { number, oneOf, oneOfType, string } from "prop-types";
import cx from "classnames";

import { genResponsiveClasses, getResponsivePropType } from "../../utils";

const propTypes = {
  /** Column offset. Number, 'center', or responsive map */
  offset: getResponsivePropType(oneOfType([number, oneOf(["center"])])),
  /** Column size. Number, 'shrink/fill/auto', or responsive map */
  size: getResponsivePropType(
    oneOfType([number, oneOf(["shrink", "fill", "auto"])])
  ),
  /** Html element. */
  tag: string,
};

const CLASS_ROOT = "grid__col";

const GridCol = ({ className, tag = "div", size, offset, ...other }) => {
  const classes = cx(
    !size && CLASS_ROOT,
    ...genResponsiveClasses(CLASS_ROOT, size),
    ...genResponsiveClasses(CLASS_ROOT, offset, "offset"),
    className
  );

  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

GridCol.displayName = "GridCol";
GridCol.propTypes = propTypes;

export default GridCol;
